import { render, staticRenderFns } from "./ProductPageDetail.vue?vue&type=template&id=dccfd6c2&scoped=true"
import script from "./ProductPageDetail.vue?vue&type=script&lang=js"
export * from "./ProductPageDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductPageDetail.vue?vue&type=style&index=0&id=dccfd6c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccfd6c2",
  null
  
)

export default component.exports